import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Search, Switch } from 'UI';
import { useBreadcrumbNavigation } from 'hooks/breadcrumb';
import { useRouteMatch } from 'react-router';

import {
  MainContainer,
  SearchContainer,
  ExtraAddButton,
  SwitchContainer,
} from './style';

interface UserListExtraProps {
  onSearch(content: string): void
  onActiveToggle(checked: boolean): void
}

const ProductListExtra = ({
  onSearch,
  onActiveToggle,
}: UserListExtraProps): JSX.Element => {
  const { url } = useRouteMatch();
  const breadcrumbNavigator = useBreadcrumbNavigation();

  return (
    <MainContainer>
      <SearchContainer>
        <Search placeholder="Buscar insumo" onSearch={onSearch} allowClear />
      </SearchContainer>
      <ExtraAddButton
        icon={<PlusOutlined size={14} />}
        onClick={() => breadcrumbNavigator.push({
          label: 'Cadastrar novo produto',
          url: `${url}/Novo`,
        })}
      >
        Cadastrar novo produto
      </ExtraAddButton>
      <SwitchContainer>
        <Switch onChange={onActiveToggle} />
      </SwitchContainer>
      <span>Filtrar inativos</span>
    </MainContainer>
  );
};

export default ProductListExtra;
